'use client';

import clsx from 'clsx';

import BackToTopIcon from '@public/icons/back-to-top.svg';
import { useScrollVisibility } from 'hooks/useScrollVisibility';

function BackToTop() {
  const isVisible = useScrollVisibility();
  const onClickButton = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!isVisible) return null;
  return (
    <button
      className={clsx(
        'fixed right-[0.375rem] z-50',
        'md:bottom-[4.875rem] sm:bottom-[4.25rem]'
      )}
      aria-label="back to top button"
      onClick={onClickButton}
    >
      <BackToTopIcon />
    </button>
  );
}

export default BackToTop;
